import React, { Component, Fragment, useEffect, useState } from 'react';
import PieChart from './Graph/PieChart'
import PercentHistogram from './Graph/PercentHistogram';
import ResponseTimePercentHistogram from './Graph/ResponseTimePercentHistogram';
import RingChart from './Graph/RingChart'
import { BiBuildings } from 'react-icons/bi';
import { IoIosGitBranch } from "react-icons/io";
import { AiOutlineCalculator } from "react-icons/ai"
import './dashboard.style.css';
import { Layout, Menu, Card, Row, Col, Divider, Table, Spin, Button, Space, message, Modal, Select } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { authSelector } from '../../Auth/authSlice';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { SyncOutlined } from '@ant-design/icons';
import { getOverview, getAllProcessCount, getProcessBreakDown, getResponseTime, viewDashboardSelector, clearState } from './AdminDashboardSlice';
import { Link } from "react-router-dom";
import { AlignRightOutlined } from '@ant-design/icons';
import Can from '../../../config/Can';

const { Header, Content, Footer, Sider } = Layout;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const style = { padding: '8px 0' };

export default function Dashboard() {

  const { Option } = Select;
  const dispatch = useDispatch();
  const [isLoading, setLoading] = React.useState(false);
  const [isToast, setToast] = React.useState(false);
  const [graphType, setgraphType] = useState('b_name');
  const [AllProcessgraphValue, setAllProcessgraphValue] = React.useState([]);
  const [BreakDowngraphValue, setBreakDowngraphValue] = React.useState([]);
  const [ResponseTimeValue, setResponseTimeValue] = React.useState([]);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const { user } = useSelector(
    authSelector
  );

  const { isFetching, isOverviewSuccess, isAllProcessCountSucess, isProcessBreakDownSuccess, isResponseTimeSuccess, isError, errorMessage, Overview, AllProcessCount, ProcessBreakDown, ResponseTime } = useSelector(
    viewDashboardSelector
  );


  useEffect(() => {
    setToast(false);
    setLoading(true);
    dispatch(clearState());
    dispatch(getOverview());
    dispatch(getAllProcessCount());
    dispatch(getProcessBreakDown(graphType));
    dispatch(getResponseTime());

  }, []);

  useEffect(() => {

    if (isError) {
      setLoading(false);
      setToast(true);
      if (errorMessage === 'Internal error')
        toast.error(errorMessage);
    }
    if (isOverviewSuccess) {
      setLoading(false);
    }
    if (isAllProcessCountSucess) {
      setAllProcessgraphValue(AllProcessCount);
    }

    if (isProcessBreakDownSuccess) {
      setBreakDowngraphValue(ProcessBreakDown);
    }

    if (isResponseTimeSuccess) {
      setResponseTimeValue(ResponseTime);
    }

  }, [isError, isOverviewSuccess, isAllProcessCountSucess, isResponseTimeSuccess, isProcessBreakDownSuccess, setLoading, Overview, AllProcessCount, ProcessBreakDown, ResponseTime]);


  const handleGraphValue = (e) => {
    dispatch(getProcessBreakDown(e));
    setgraphType('');
    setgraphType(e);
  }


  return (
    <>

      <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
      {isToast &&
        <Toaster
          toastOptions={{
            className: '',
            style: {
              border: '1px solid #713200',
              padding: '16px',
              color: '#713200',
              marginTop: 50
            },
          }}
        >
          {(t) => (
            <ToastBar toast={t}>
              {({ icon, message }) => (
                <>
                  {icon}
                  {message}
                  {t.type !== 'loading' && (
                    <button onClick={() => toast.dismiss(t.id)}>X</button>
                  )}
                </>
              )}
            </ToastBar>
          )}
        </Toaster>
      }


      <Content>
        <div className="dashboard-titl-btn-mng">
          <h1 style={{ color: '#ffffff', fontWeight: 700, fontSize: '30px' }}>Dashboard</h1>
          <Can I="dashboardTab" a="viewDistributionList">
            {() => <Link to="/distribution-list"><Button size="large" style={{ backgroundColor: 'transparent', borderRadius: 5, padding: '6px 9px', fontWeight: 600, fontSize: 20, color: '#ffffff', border: 'none', boxShadow: 'none' }} type="" icon={<AlignRightOutlined />}>Distribution List</Button></Link>}
          </Can>
        </div>
        {/* <Link to="/distribution-list"><Button size="large" style={{borderRadius:5,padding:'6.4px 8px',fontWeight:600,fontSize:20,color:'#0053df',border:'none',boxShadow:'none'}}  type="default" icon={<AlignRightOutlined />}>Distribution List</Button></Link> */}
        <Row>
          <Col className="border-radius-7" span={10} style={{ border: "1px solid #e3e5ee", backgroundColor: "#ffffff" }}>
            <h2 style={{ paddingLeft: 20, paddingTop: 5, fontWeight: 700, color: '#172b4d' }}>All Process</h2>
            <PieChart isGraphData={AllProcessgraphValue} />
          </Col>
          <Col span={14} style={{ paddingLeft: '20px' }}>
            <div className="border-radius-7" style={{ border: '1px solid #e3e5ee', backgroundColor: "#ffffff", paddingLeft: 24, paddingRight: 24, paddingBottom: 30 }}>
              <h2 style={{ paddingTop: 5, fontWeight: 700, color: '#172b4d' }}>Overview</h2>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="gutter-row" span={8}>
                  <div style={style, { background: "#2F6CDE", padding: 10, paddingLeft: 15, borderRadius: 5 }}>
                    <Row>
                      <Col span="20" style={{ color: "#FFFFFF", fontSize: 25, fontWeight: 'bold' }}>
                        {Overview && Overview.totalBranch ? Overview.totalBranch : 0}
                      </Col>
                      <Col span="4" className='dashboard-overview-icon'>
                        <img src="/newicons/businessBlack.svg" alt="image" style={{ height: 20, margin: '10px' }} />
                      </Col>
                    </Row>
                    <Row >
                      <Col span="24" style={{ color: "#FFFFFF", fontSize: 16 }}>
                        Total Branches
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col className="gutter-row" span={8}>
                  <div style={style, { background: "#B6A925", padding: 10, paddingLeft: 15, borderRadius: 5 }}>
                    <Row>
                      <Col span="20" style={{ color: "#FFFFFF", fontSize: 25, fontWeight: 'bold' }}>
                        {Overview && Overview.directoratesWithinBranch ? Overview.directoratesWithinBranch : 0}
                      </Col>
                      <Col span="4" className='dashboard-overview-icon'>
                        {/* <IoIosGitBranch/> */}
                        <img src="/newicons/gitBranch.svg" alt="image" style={{ height: 20, margin: '10px' }} />
                      </Col>
                    </Row>
                    <Row>
                      <Col span="24" style={{ color: "#FFFFFF", fontSize: 16 }}>
                        Directorates in Branches
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col className="gutter-row" span={8}>
                  <div style={style, { background: "#7B7FDE", padding: 10, paddingLeft: 15, borderRadius: 5 }}>
                    <Row>
                      <Col span="20" style={{ color: "#FFFFFF", fontSize: 25, fontWeight: 'bold' }}>
                        {Overview && Overview.CHD ? Overview.CHD : 0}
                      </Col>
                      <Col span="4" className='dashboard-overview-icon'>
                        <img src="/newicons/divideSquare.svg" alt="image" style={{ height: 20, margin: '10px' }} />
                      </Col>
                    </Row>
                    <Row>
                      <Col span="24" style={{ color: "#FFFFFF", fontSize: 16 }}>
                        Total CHD
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Divider />
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="gutter-row" span={8}>
                  <div style={style, { background: "#BD34EB", padding: 10, paddingLeft: 15, borderRadius: 5 }}>
                    <Row>
                      <Col span="20" style={{ color: "#FFFFFF", fontSize: 25, fontWeight: 'bold' }}>
                        {Overview && Overview.DDAndAd ? Overview.DDAndAd : 0}
                      </Col>
                      <Col span="4" className='dashboard-overview-icon'>
                        <img src="/newicons/settings.svg" alt="image" style={{ height: 20, margin: '10px' }} />
                      </Col>
                    </Row>
                    <Row>
                      <Col span="24" style={{ color: "#FFFFFF", fontSize: 16 }}>
                        Total DD's & AD's
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col className="gutter-row" span={8}>
                  <div style={style, { background: "#26D2B1", padding: 10, paddingLeft: 15, borderRadius: 5 }}>
                    <Row>
                      <Col span="20" style={{ color: "#FFFFFF", fontSize: 25, fontWeight: 'bold' }}>
                        {Overview && Overview.Clerk ? Overview.Clerk : 0}
                      </Col>
                      <Col span="4" className='dashboard-overview-icon'>
                        <img src="/newicons/calculateBlack.svg" alt="image" style={{ height: 20, margin: '10px' }} />
                      </Col>
                    </Row>
                    <Row>
                      <Col span="24" style={{ color: "#FFFFFF", fontSize: 16 }}>
                        Total Clerks
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col className="gutter-row" span={8}>
                  <div style={style, { background: "#E84C32", padding: 10, paddingLeft: 15, borderRadius: 5 }}>
                    <Row>
                      <Col span="20" style={{ color: "#FFFFFF", fontSize: 25, fontWeight: 'bold' }}>
                        {Overview && Overview.totalPendingActions ? Overview.totalPendingActions : 0}
                      </Col>
                      <Col span="4" className='dashboard-overview-icon'>
                        <img src="/newicons/clock.svg" alt="image" style={{ height: 20, margin: '10px' }} />
                      </Col>
                    </Row>
                    <Row>
                      <Col span="24" style={{ color: "#FFFFFF", fontSize: 16 }}>
                        Total Pending Actions
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              {/* <Row>
              <Col  span={8} style={{padding:15}}>
              <Card  style={{ border: "1px solid #000" }}>
                  <p style={{textAlign:'right',paddingRight:"0px",marginTop:"-20px",marginRight:-15}}><InfoCircleOutlined  style={{fontSize: '15px', color: '#000'}}/></p>
                  <p style={{color:'#000',fontSize:25,textAlign:'center',fontWeight:'bold'}}>20</p>
                  <p style={{textAlign:'center',fontSize:15,marginTop:' -25px'}}>Total  <br/> Departments</p>
              </Card>
              </Col>
              <Col  span={8} style={{padding:15}}>
              <Card  style={{ border: "1px solid #000" }}>
                  <p style={{textAlign:'right',paddingRight:"10px",marginTop:"-20px",marginRight:-15}}><InfoCircleOutlined  style={{fontSize: '15px', color: '#000'}}/></p>
                  <p style={{color:'#000',fontSize:25,textAlign:'center',fontWeight:'bold'}}>11</p>
                  <p style={{textAlign:'center',fontSize:15,marginTop:' -25px'}}>Total <br/> Branches</p>
              </Card>
              </Col>
              <Col  span={8} style={{padding:15}}>
              <Card  style={{ border: "1px solid #000" }}>
                  <p style={{textAlign:'right',paddingRight:"10px",marginTop:"-20px",marginRight:-15}}><InfoCircleOutlined  style={{fontSize: '15px', color: '#000'}}/></p>
                  <p style={{color:'#000',fontSize:25,textAlign:'center',fontWeight:'bold'}}>11</p>
                  <p style={{textAlign:'center',fontSize:15,marginTop:' -25px'}}>Total <br/>CHD</p>
              </Card>
              </Col>
              </Row> */}
              {/* <Row>
              <Col  span={8} style={{padding:15}}>
              <Card  style={{ border: "1px solid #000" }}>
                  <p style={{textAlign:'right',paddingRight:"0px",marginTop:"-20px",marginRight:-15}}><InfoCircleOutlined  style={{fontSize: '15px', color: '#000'}}/></p>
                  <p style={{color:'#000',fontSize:25,textAlign:'center',fontWeight:'bold'}}>20</p>
                  <p style={{textAlign:'center',fontSize:15,marginTop:' -25px'}}>Total  <br/> Advanced</p>
              </Card>
              </Col>
              <Col  span={8} style={{padding:15}}>
              <Card  style={{ border: "1px solid #000" }}>
                  <p style={{textAlign:'right',paddingRight:"10px",marginTop:"-20px",marginRight:-15}}><InfoCircleOutlined  style={{fontSize: '15px', color: '#000'}}/></p>
                  <p style={{color:'#000',fontSize:25,textAlign:'center',fontWeight:'bold'}}>11</p>
                  <p style={{textAlign:'center',fontSize:15,marginTop:' -25px'}}>Total <br/> Clerks</p>
              </Card>
              </Col>
              <Col  span={8} style={{padding:15}}>
              <Card  style={{ border: "1px solid #000" }}>
                  <p style={{textAlign:'right',paddingRight:"10px",marginTop:"-20px",marginRight:-15}}><InfoCircleOutlined  style={{fontSize: '15px', color: '#000'}}/></p>
                  <p style={{color:'#000',fontSize:25,textAlign:'center',fontWeight:'bold'}}>11</p>
                  <p style={{textAlign:'center',fontSize:15,marginTop:' -25px'}}>Total Pending<br/>Actions</p>
              </Card>
              </Col>
              </Row> */}
            </div>
          </Col>
        </Row>


        <Row style={{ padding: "0px 0px 0px 0px" }}>

          <Col span={14} style={{ padding: "18px 18px 0px 0px", marginBottom: "20px" }}>
            <div className="border-radius-7" style={{ padding: "20px 16px 0px 20px", backgroundColor: "#ffffff", border: "1px solid #e3e5ee" }}>
              <p className="process-breakdown-transformyaxis" >Total Process</p>
              <h2 style={{ position: 'absolute', fontWeight: 700, color: '#172b4d', top: '34px' }}>Process Breakdown</h2>

              <Select style={{ margin: "50px 20px 0px 0px" }} onChange={handleGraphValue} placeholder="Branch" className="dashboard-breakdown-process-dropdon dropdown-arrow-ant-custom" allowClear>
                <Option value="b_name">Branch</Option>
                <Option value="bd_name">Branch Directorate</Option>
                <Option value="io_name">Independent Office</Option>
                <Option value="id_name">Independent Directorate</Option>
              </Select>
              <div style={{ height: 350 }}>
                <PercentHistogram datainGraph={BreakDowngraphValue} />
              </div>
              <p style={{ color: "#8c8ea2", textAlign: 'center' }}>Status</p>
            </div>
          </Col>
          {/* <Col span={1}></Col> */}
          <Col span={10} style={{ padding: "18px 0px 0px 0px", marginBottom: "20px" }}>
            <div className="border-radius-7" style={{ padding: "20px 16px 0px 20px", backgroundColor: "#ffffff", border: "1px solid #e3e5ee" }}>
              <p className="response-time-transformyaxis" >Response</p>
              <h2 style={{ position: 'absolute', fontWeight: 700, color: '#172b4d', top: '34px' }}>Response Time</h2>
              <div style={{ height: 350, marginTop: 84 }}>
                <ResponseTimePercentHistogram datainGraph={ResponseTimeValue} />
              </div>
              <p style={{ color: "#8c8ea2", textAlign: 'center' }}>Time</p>
            </div>
          </Col>
        </Row>

      </Content>
    </>
  );
}
